import { render, staticRenderFns } from "./purchase_order_detail.vue?vue&type=template&id=0e7f4624&scoped=true&"
import script from "./purchase_order_detail.vue?vue&type=script&lang=js&"
export * from "./purchase_order_detail.vue?vue&type=script&lang=js&"
import style0 from "./purchase_order_detail.vue?vue&type=style&index=0&id=0e7f4624&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7f4624",
  null
  
)

export default component.exports